import WithSidebar from './WithSidebar';

export default WithSidebar;



// WEBPACK FOOTER //
// ./src/components/WithSidebar/index.js